<div class="container">

<h2 class="rounded text-center">Verify Logs</h2>
<div class="row">
    <mat-form-field class="col-md-12" appearance="outline">
        <mat-label>Status</mat-label>
        <mat-select [(ngModel)]="status">
            <mat-option value="Pending">Pending</mat-option>
            <mat-option value="Verified">Verified</mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field   class="col-md-12" appearance="outline" >
        <mat-label>Enter Remark</mat-label>
        <textarea  matInput [(ngModel)]="remark"></textarea>
    </mat-form-field>
<button mat-stroked-button color="primary" (click)="onSubmit()">Submit</button>
</div>
</div>
